import { render, staticRenderFns } from "./contractFile.vue?vue&type=template&id=723e6330&scoped=true&"
import script from "./contractFile.vue?vue&type=script&lang=js&"
export * from "./contractFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "723e6330",
  null
  
)

export default component.exports